import React, { FC } from "react";
import { PartnerType } from "../../data";
import { PartnerForm } from "../components/partner-form";
import { ConnectionList, PartnersList, PartnerView } from "../components";



/**
 * Tawreed Stores Page
 * @returns 
 */
export const StoresPage: FC = () => (<PartnersList />);
/**
 * Tawreed Store Form Page
 * @returns 
 */
export const StoreFormPage: FC = () => (<PartnerForm type={PartnerType.Store} />);

export const CustomerDetailsPage: FC = () => (<PartnerView />);

// /**
//  * Tawreed Store Form Page
//  * @returns 
//  */
// export const ConnectionFormPage: FC = () => (<PartnerForm type={PartnerType.Store} />);


/**
 * Tawreed Stores Page
 * @returns 
 */
export const ConnectionsPage: FC = () => (<ConnectionList />);
